export function getIcon(id){
    return process.env.PUBLIC_URL+'/asset/'+id+'.svg'
}
